var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-auto",
                  attrs: { height: "500", elevation: "4" }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "font-weight-bold light-blue-bg" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mx-0", attrs: { align: "center" } },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("home.noOfTrips")) + " "),
                          _c("v-spacer"),
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "mr-2",
                              attrs: { mandatory: "", dense: "", rounded: "" },
                              model: {
                                value: _vm.tripsByDayViewMode,
                                callback: function($$v) {
                                  _vm.tripsByDayViewMode = $$v
                                },
                                expression: "tripsByDayViewMode"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                { attrs: { value: "aggregated", small: "" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("charts.aggregated")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "v-btn",
                                { attrs: { value: "detailed", small: "" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("charts.detailed")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "nudge-right": 40,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              staticStyle: {
                                                "max-width": "150px"
                                              },
                                              attrs: {
                                                label: _vm.$t("home.startDate"),
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.tripsStartDate,
                                                callback: function($$v) {
                                                  _vm.tripsStartDate = $$v
                                                },
                                                expression: "tripsStartDate"
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.startDateMenu,
                                callback: function($$v) {
                                  _vm.startDateMenu = $$v
                                },
                                expression: "startDateMenu"
                              }
                            },
                            [
                              _c("v-date-picker", {
                                attrs: { max: _vm.tripsEndDate },
                                on: {
                                  input: function($event) {
                                    _vm.startDateMenu = false
                                  }
                                },
                                model: {
                                  value: _vm.tripsStartDate,
                                  callback: function($$v) {
                                    _vm.tripsStartDate = $$v
                                  },
                                  expression: "tripsStartDate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                                left: ""
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticStyle: {
                                                "max-width": "150px"
                                              },
                                              attrs: {
                                                label: _vm.$t("home.endDate"),
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                dense: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.tripsEndDate,
                                                callback: function($$v) {
                                                  _vm.tripsEndDate = $$v
                                                },
                                                expression: "tripsEndDate"
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.endDateMenu,
                                callback: function($$v) {
                                  _vm.endDateMenu = $$v
                                },
                                expression: "endDateMenu"
                              }
                            },
                            [
                              _c("v-date-picker", {
                                attrs: {
                                  min: _vm.tripsStartDate,
                                  max: _vm.today
                                },
                                on: {
                                  input: function($event) {
                                    _vm.endDateMenu = false
                                  }
                                },
                                model: {
                                  value: _vm.tripsEndDate,
                                  callback: function($$v) {
                                    _vm.tripsEndDate = $$v
                                  },
                                  expression: "tripsEndDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-skeleton-loader",
                    {
                      attrs: {
                        loading: _vm.numberOfTripsLoading,
                        "transition-group": "scale-transition",
                        type: "list-item@7"
                      }
                    },
                    [
                      _c("BarChart", {
                        attrs: {
                          "chart-data": _vm.tripsByDayChartData,
                          options: _vm.tripsByDayDataOptions
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                { attrs: { elevation: "4" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "font-weight-bold light-blue-bg" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("home.transportEventErrors")) + " "
                      )
                    ]
                  ),
                  _c(
                    "v-skeleton-loader",
                    {
                      attrs: {
                        loading: _vm.failedValidationsLoading,
                        "transition-group": "scale-transition",
                        type: "list-item@3"
                      }
                    },
                    [
                      _c("v-simple-table", {
                        attrs: { height: "500px" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { staticClass: "text-left" }, [
                                      _vm._v(_vm._s(_vm.$t("home.errorType")))
                                    ]),
                                    _c("th", { staticClass: "text-left" }, [
                                      _vm._v(_vm._s(_vm.$t("home.errorCount")))
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.failReasons, function(failReason) {
                                    return _c(
                                      "tr",
                                      {
                                        key: failReason.item1,
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            return _vm.searchFailed(
                                              failReason.item1
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f(
                                                "validationFailReasonToText"
                                              )(failReason.item1)
                                            )
                                          )
                                        ]),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "error--text font-weight-bold"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(failReason.item2) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-auto",
                  attrs: { height: "500px", elevation: "4" }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "font-weight-bold light-blue-bg" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mx-0", attrs: { align: "center" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("home.statusesOfLastXDays", {
                                  days: _vm.tripStatusesFromDays
                                })
                              ) +
                              " "
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn-toggle",
                            {
                              attrs: { mandatory: "", dense: "", rounded: "" },
                              model: {
                                value: _vm.tripStatusesFromDays,
                                callback: function($$v) {
                                  _vm.tripStatusesFromDays = $$v
                                },
                                expression: "tripStatusesFromDays"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                { attrs: { value: "30", small: "" } },
                                [_vm._v(" 30 ")]
                              ),
                              _c(
                                "v-btn",
                                { attrs: { value: "60", small: "" } },
                                [_vm._v(" 60 ")]
                              ),
                              _c(
                                "v-btn",
                                { attrs: { value: "90", small: "" } },
                                [_vm._v(" 90 ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-skeleton-loader",
                    {
                      attrs: {
                        loading: _vm.tripStatusesLoading,
                        "transition-group": "scale-transition",
                        type: "list-item@5"
                      }
                    },
                    [
                      _c("DoughnutChart", {
                        attrs: {
                          data: _vm.tripsByTimeRangeData,
                          options: _vm.tripsByTimeRangeDataOptions
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }